"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionType = void 0;
var QuestionType;
(function (QuestionType) {
    QuestionType["Simple"] = "Simple";
    QuestionType["Multiple"] = "Multiple";
    QuestionType["MultipleCheckboxes"] = "MultipleCheckboxes";
    QuestionType["PhoneNumber"] = "PhoneNumber";
    QuestionType["NotificationPhoneNumber"] = "NotificationPhoneNumber";
    QuestionType["Email"] = "Email";
    QuestionType["Date"] = "Date";
    QuestionType["Checkbox"] = "Checkbox";
    QuestionType["Utm"] = "Utm";
    QuestionType["Name"] = "Name";
    QuestionType["Address"] = "Address";
})(QuestionType || (exports.QuestionType = QuestionType = {}));
